var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBugLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedIn bug") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-row",
    transform: "translate(-260.000000, 2.000000)",
    fill: "#2C5D9B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-35",
    transform: "translate(260.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3465968,0.00208705128 L1.46200446,0.00208705128 C0.664047196,-0.00717124055 0.0100891149,0.637205871 0,1.44267726 L0,18.5575556 C0.00917192259,19.3630269 0.664047196,20.0092557 1.46200446,20.0001163 L18.3465968,20.0001163 C19.1473056,20.0101815 19.8030981,19.3648786 19.8150216,18.5575556 L19.8150216,1.44175143 C19.8030981,0.634428384 19.1463884,-0.0099487281 18.3465968,0.000116321694 L18.3465968,0.00208705128 Z M2.93776681,17.0419732 L5.877368,17.0419732 L5.877368,7.49760012 L2.93776681,7.49760012 L2.93776681,17.0419732 Z M4.40894319,6.1931068 C3.46790393,6.1931068 2.70479997,5.42374275 2.70479997,4.47384201 C2.70479997,3.52394127 3.46698674,2.75365055 4.408026,2.75365055 C5.34906526,2.75272556 6.11216922,3.52301544 6.11216922,4.47291618 C6.11216922,5.42281692 5.34998245,6.1931068 4.40894319,6.1931068 L4.40894319,6.1931068 Z M16.8827579,17.0419732 L13.9477427,17.0419732 L13.9477427,12.4007915 C13.9477427,11.2944256 13.9275645,9.86957449 12.4206176,9.86957449 C10.8916581,9.86957449 10.6568569,11.0759299 10.6568569,12.3202443 L10.6568569,17.0419732 L7.72184163,17.0419732 L7.72184163,7.49760012 L10.5394563,7.49760012 L10.5394563,8.80209344 L10.5788955,8.80209344 C11.1539751,7.80960456 12.222504,7.21799971 13.3607396,7.26058785 C16.3361113,7.26058785 16.8845923,9.2353815 16.8845923,11.8064091 L16.8827579,17.0419732 L16.8827579,17.0419732 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBugLinkedIn);
export default __webpack_public_path__ + "static/media/icon-bug-linkedIn.fcb4d5ebf0b49c99f3e129f3ca5a7d0d.svg";
export { ForwardRef as ReactComponent };